export const CONTACTS_PAGE_SIZE = 20;
